import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CategoryService } from 'app/services/category/category.service';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';
import { GalleryPickerComponent } from 'app/shared/gallery-picker/gallery-picker.component';
import { ImageFallbackDirective } from 'app/modules/admin/directives/ImageFallbackDirective';
import { ImageItem } from 'app/services/gallery/gallery.service';

@Component({
  selector: 'app-add-category',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ImageUrlPipe,
    GalleryPickerComponent,
    ImageFallbackDirective
  ],
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent implements OnInit {
  categoryForm: FormGroup;
  parentCategories: any[] = [];
  isLoading = false;
  isSubmitting = false;

  isGalleryModalOpen = false;
  selectedPhotos: ImageItem[] = [];
  selectedIconId: number | null = null;
  imagePreview: string | null = null;

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private router: Router
  ) {
    this.categoryForm = this.createForm();
  }

  ngOnInit() {
    this.loadParentCategories();
  }

  createForm(): FormGroup {
    return this.fb.group({
      parentId: [0, [Validators.required, Validators.min(0)]],
      level: [0, [Validators.required, Validators.min(0)]],
      code: ['', [Validators.required, Validators.minLength(1)]],
      arName: ['', [Validators.required, Validators.minLength(2)]],
      enName: ['', [Validators.required, Validators.minLength(2)]],
      icon: [null],
      featured: [false],
      top: [false],
slug: [
  '',
  [
    Validators.required,
    Validators.pattern(/^[a-zA-Z0-9]+$/)
  ]
],      status: [true]
    });
  }

  loadParentCategories() {
    this.isLoading = true;
    this.categoryService.getSubCategories().subscribe({
      next: (response) => {
        this.parentCategories = response.data || [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading parent categories:', error);
        this.isLoading = false;
        this.parentCategories = [];
      }
    });
  }

  openGalleryModal(): void {
    this.isGalleryModalOpen = true;
  }

  closeGalleryModal(): void {
    this.isGalleryModalOpen = false;
  }

  onGalleryImagesChange(images: ImageItem[]): void {
  this.selectedPhotos = images || [];

  const firstImage = this.selectedPhotos[0];
  this.selectedIconId = firstImage ? Number(firstImage.id) : null;
  this.imagePreview = firstImage?.url || null;
  this.categoryForm.patchValue({
    icon: this.selectedIconId
  });

  this.closeGalleryModal();
}

  removeImage(): void {
    this.selectedPhotos = [];
    this.selectedIconId = null;
    this.imagePreview = null;

    this.categoryForm.patchValue({
      icon: null
    });
  }

  validateDiscountDates(): boolean {
    return true;
  }

  async onSubmit() {
    if (this.categoryForm.invalid) {
      this.markAllFieldsAsTouched();
      return;
    }

    this.isSubmitting = true;

    try {
      const formData = {
        ...this.categoryForm.value,
        icon: this.selectedIconId
      };
      this.categoryService.createCategory(formData).subscribe({
        next: () => {
          this.isSubmitting = false;
          alert('✅ Category added successfully!');
          this.router.navigateByUrl('/admin/categories');
        },
        error: (error) => {
          this.isSubmitting = false;
          console.error('❌ Error adding category:', error);
          alert('⚠️' + (error?.error?.message || 'Error adding category'));
        }
      });
    } catch (error) {
      this.isSubmitting = false;
      console.error('❌ Error preparing form data:', error);
      alert('⚠️ Error preparing form data.');
    }
  }

  markAllFieldsAsTouched() {
    Object.keys(this.categoryForm.controls).forEach(key => {
      this.categoryForm.get(key)?.markAsTouched();
    });
  }

  showError(controlName: string): boolean {
    const control = this.categoryForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getError(controlName: string): string {
    const control = this.categoryForm.get(controlName);
    if (control?.errors) {
      if (control.errors['required']) return 'This field is required';
      if (control.errors['minlength']) return `Minimum length is ${control.errors['minlength'].requiredLength}`;
      if (control.errors['min']) return `Minimum value is ${control.errors['min'].min}`;
      if (control.errors['max']) return `Maximum value is ${control.errors['max'].max}`;
    }
    return 'Invalid value';
  }

  getCategoryName(category: any): string {
    return category?.name || category?.enName || 'Unnamed Category';
  }

  goBack() {
    this.router.navigateByUrl('/admin/categories');
  }


}